import { FrLoginInterfaceMapper } from '@shared/lib/models/fr-login-interface-mapper';
import { FrLoginInterface } from '@shared/lib/models/fr-login-interface.enum';

export class BaoyingFrLoginInterfaceMapper extends FrLoginInterfaceMapper {
  loadComponentForInterface(frInterface: FrLoginInterface): Promise<any> {
    return new Promise<any>((resolve) => {
      switch (frInterface) {
        case FrLoginInterface.USERNAME_PASSWORD:
          import('@shared/lib/components/login-interface/username/login-interface-username.component').then(
            ({ LoginInterfaceUsernameComponent }) => {
              resolve(LoginInterfaceUsernameComponent);
            }
          );
          break;
        case FrLoginInterface.CHOICE:
          import('@shared/lib/components/login-interface/choice/login-interface-choice.component').then(
            ({ LoginInterfaceChoiceComponent }) => {
              resolve(LoginInterfaceChoiceComponent);
            }
          );
          break;
        case FrLoginInterface.SESSION_EXPIRED:
          import(
            '@shared/lib/components/login-interface/session-expired/login-interface-session-expired.component'
          ).then(({ LoginInterfaceSessionExpiredComponent }) => {
            resolve(LoginInterfaceSessionExpiredComponent);
          });
          break;
        default:
          import('@shared/lib/components/login-interface/unknown/login-interface-unknown.component').then(
            ({ LoginInterfaceUnknownComponent }) => {
              resolve(LoginInterfaceUnknownComponent);
            }
          );
          break;
      }
    });
  }
}
